module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "h-100",
    attrs: {
      "id": "planning-absences"
    }
  }, [_c('calendrier-component', {
    ref: "calendrierComponent",
    attrs: {
      "typeCalendrier": _vm.typeCalendrierPlanningDesAbsences
    },
    on: {
      "generationCRPCEN": _vm.generationCRPCEN,
      "addAbsenceImposee": _vm.onAddAbsenceImposee,
      "addAbsence": _vm.onAddAbsence,
      "deleteAbsenceImposee": _vm.onDeleteAbsenceImposee
    }
  }), _vm._v(" "), _c('modal-ajouter-absence-component', {
    ref: "modalAjouterAbsence",
    attrs: {
      "isActionSalarie": false
    },
    on: {
      "enregistrerAbsenceOk": _vm.enregistrerAbsenceOk,
      "enregistrementAbsenceCollectiveOk": _vm.enregistrementAbsenceCollectiveOk,
      "generationCRPCEN": _vm.generationCRPCEN
    }
  }), _vm._v(" "), _c('modal-generation-attestation-component', {
    ref: "modalGenerationCRPCEN"
  }), _vm._v(" "), _c('modal-ajout-absence-imposee-contrat-component', {
    ref: "modalAjoutAbsenceImposeeContrat",
    on: {
      "enregistrementOk": _vm.enregistrementAbsenceImposeeOk
    }
  }), _vm._v(" "), _c('modal-suppression-absence-imposee-date-component', {
    ref: "modalSuppressionAbsenceImposeeDate",
    on: {
      "enregistrementOk": _vm.enregistrementSuppressionAbsenceImposeeDateOk,
      "annulationAbsenceCalculee": _vm.ouvrirPopupAlerteAnnulation
    }
  }), _vm._v(" "), _c('modal-suppression-absence-imposee-contrat-component', {
    ref: "modalSuppressionAbsenceImposeeContrat",
    on: {
      "enregistrementOk": _vm.enregistrementSuppressionAbsenceImposeeOk
    }
  }), _vm._v(" "), _c('modal-alerte-absence-calculee-component', {
    ref: "modalAlerteAbsenceCalculee",
    attrs: {
      "data-backdrop": "static"
    },
    on: {
      "annulerAbsence": _vm.enregistrementSuppressionAbsenceImposeeDateOk,
      "garderAbsence": _vm.onDeleteAbsenceImposee
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bbc7710"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/planningAbsences/planningAbsences.vue.html
// module id = 2Yat
// module chunks = 2